/**
 * Enum representing the different modes for participant selection.
 * - AGE: Participants are selected by age range
 * - CONSUMER_CATEGORY: Participants are selected by consumer category (e.g., Adult, Child, Senior)
 */
export enum SELECTOR_MODE {
  AGE = 'age',
  CONSUMER_CATEGORY = 'consumercategory',
}
